import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './router/permission'
import 'element-plus/dist/index.css'
import ElementPlus from 'element-plus'
import svgIcon from '@/components/icon/svg.vue'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import './assets/css/main.css'
import './assets/css/form.css'
import 'src/assets/sass/black-dashboard-pro.scss';
import 'src/assets/css/nucleo-icons.css';
import 'src/assets/css/matrix-icons.css'
import 'src/assets/css/demo.css';
import '@/components/icon/index.js'

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);//store持久化
const app = createApp(App)
app.use(pinia)
app.use(router)
app.use(ElementPlus)
app.component('svg-icon', svgIcon)
app.mount('#app')
